import { CelumMap, EntityType } from '@celum/core/model';

import { OperationDefinition } from './operation-definition';

export class OperationsMap extends CelumMap<EntityType, OperationDefinition[]> {
  public translateKey(key: EntityType): string {
    return key.id;
  }
}
